export default class InvalidArgumentError extends Error {
}
